import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { filter, firstValueFrom, map, observable, Observable, of, startWith, Subscription, take } from "rxjs";
import { MapHelperService } from "../../../../../../services/map-helper.service";
import { PanelDetailGeofencesService } from "../../../services/Panel-Detail-Geofences.service";
import { PanelAddGeofencesService } from "../../../services/Panel-Add-Geofences.service";
import { EnumGeofenceTypes } from "../../../../shared/helpers/enums/EnumGeofenceTypes";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from "@angular/material/legacy-tabs";
import { addGeofencesRequestDTO } from "../../../models/addGeofences/addGeofencesRequestDTO";
import { MediaMatcher } from "@angular/cdk/layout";
import { GeofencesService } from "../../../services/Geofences.service";
import { LocationDTO } from "src/app/features/locations-map/models/LocationDTO";
import { LocationsService } from "src/app/features/locations-map/services/Locations.service";
import { TutorialService } from "src/app/features/shared/features/tutorial/services/tutorial.service";
import { EnumGeometryTypes } from "src/app/features/shared/helpers/enums/EnumGeometryTypes";
import { EnumResponse } from "src/app/features/shared/models/EnumResponse";
import { MapService } from "src/app/features/shared/services/Map.service";
import { NotificationsToastService } from "src/app/features/shared/services/Notifications-Toast.service";
import { EnumsService } from "src/app/features/shared/services/ServiceCatalogEncapsulators/Enums.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { PanelInternalLayerService } from "src/app/features/locations-map/services/Panel-Internal-Layer.service";
import { EnumFeaturesActionsDestinations } from "src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations";

@Component({
  selector: 'app-panel-edit-geofences',
  templateUrl: './panel-edit-geofences.component.html',
  styleUrls: ['./panel-edit-geofences.component.css']
})
export class PanelEditGeofencesComponent implements OnInit, OnDestroy {

  EnumGeometryTypes = EnumGeometryTypes;

  filteredOptionsVehicules: Observable<string[]>;
  controlVehicules = new FormControl();
  listIdentifiers: string[] = [];
  listIdentifiersFinderBackup: string[] = [];
  listLocationsFind: LocationDTO[] = [];
  intersectedFeatures: any;
  $intersectedFeatures : Observable<any> = new Observable<any>();
  listGeofenceTypes: EnumResponse[] = [];
  listGeofenceCategories: EnumResponse[] = [];
  public $guidEditable: string = "";
  public $isDuplicate: boolean = false;

  initialRadio: string = "0.1";
  fullRequest: addGeofencesRequestDTO = {
    guid: "",
    status: true,
    name: "",
    coords: [],
    multiplePolygonCoords: [],
    identifiers: [],
    radio: this.initialRadio,
    idGeofenceType: EnumGeofenceTypes.SecureZone_AlertOnExit,
    emailAlert: localStorage.getItem("user"),
    idGeometryType: -1,
    idGeofenceCategory: 1,
    alarmType: "full",
    alarmFrecuency: "",
    alarmDays: [],
    alarmIndividualTime: [],
    alarmRangeTime: [],
    phoneAlert: "",
  };
  vehiculoInput: string;
  vehiculos: string ="";

  isVisibleDetails: boolean;
  public isLoading: boolean = false;
  selectedTabIndex: number = 0;
  horaInicio: string = "06:00 AM";
  horaFin: string = "06:00 AM";
  diaInicial: any = "";
  diaFinal: any = "";
  horasTotales: number = 0;
  diasTotales: number = 0;
  rangoCalculado: string = "";
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  days = [
    { name: 'Lunes', initial: 'L', selected: false },
    { name: 'Martes', initial: 'M', selected: false },
    { name: 'Miércoles', initial: 'X', selected: false },
    { name: 'Jueves', initial: 'J', selected: false },
    { name: 'Viernes', initial: 'V', selected: false },
    { name: 'Sábado', initial: 'S', selected: false },
    { name: 'Domingo', initial: 'D', selected: false },
  ];
  isMapix: any;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  subscription_GetFeatures: Subscription;
  subscription_GetFeofence: Subscription;
  subscription_OnFocusPin: Subscription;
  subscription_FindByIdentifier: Subscription;
  subscription_GetList: Subscription;
  subscription_InsertV2: Subscription;
  subscription_validateIdentifier: Subscription;
  subscription_GetGeofenceTypes: Subscription;
  subscription_getLoading: Subscription;

  constructor(
    private sessionService: SessionService,
    private panelGeofenceDetailService: PanelDetailGeofencesService,
    private panelAddGeofencesService: PanelAddGeofencesService,
    private mapHelperService: MapHelperService,
    private mapService: MapService,
    private geofencesService: GeofencesService,
    private notificationToastService: NotificationsToastService,
    private notifyService: SwalNotificationService,
    private locationService: LocationsService,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
    private enumCatalogService: EnumsService,
    private tutorialService: TutorialService,
    private internalLayerService: PanelInternalLayerService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);

    this.subscription_getLoading = this.panelGeofenceDetailService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

    // this.$intersectedFeatures = this.panelAddGeofencesService.getIntersectedFeatures();
    this.subscription_GetFeatures = this.mapHelperService.featuresInsideArea$.pipe(
      filter(data => data && data.featureCollection.features.length > 0 && data.destination == EnumFeaturesActionsDestinations.Geofences)
    ).subscribe(data => {
      this.intersectedFeatures = data.featureCollection.features;
      console.log("cambio de features", this.intersectedFeatures);
      this.setFeaturesToActives(this.intersectedFeatures);
    });
    this.panelAddGeofencesService.setVisibleControlSliderRadio(false);
    this.$guidEditable = this.panelAddGeofencesService.$guidEditable;
    this.$isDuplicate = this.panelAddGeofencesService.$isDuplicate;
  }

  ngOnInit(): void {
    this.checkingURL();
    this.GetGeofenceEnums();
    if (this.$guidEditable != "") {
      this.UpdateEditGeofences(this.$guidEditable);
    }
  }

  ngAfterViewInit(): void {
    this.tutorialService.startTutorial(["panelAddGeofenceTutorial"]);
  }

  ngOnDestroy(): void {
    if (this.subscription_GetFeofence)
      this.subscription_GetFeofence.unsubscribe();
    if (this.subscription_FindByIdentifier)
      this.subscription_FindByIdentifier.unsubscribe();
    if (this.subscription_GetList)
      this.subscription_GetList.unsubscribe();
    if (this.subscription_InsertV2)
      this.subscription_InsertV2.unsubscribe();
    if (this.subscription_validateIdentifier)
      this.subscription_validateIdentifier.unsubscribe();
    if (this.subscription_GetFeatures)
      this.subscription_GetFeatures.unsubscribe();
    if (this.subscription_OnFocusPin)
      this.subscription_OnFocusPin.unsubscribe();
    if (this.subscription_GetGeofenceTypes)
      this.subscription_GetGeofenceTypes.unsubscribe();
    if (this.subscription_getLoading)
      this.subscription_getLoading.unsubscribe();
    this.cleanForm();
  }

  UpdateEditGeofences($identifier) {
    // this.PanelGeofencesService.setLoading(true);
    this.subscription_GetFeofence = this.geofencesService.get($identifier).subscribe((data: EstatusJSON) => {
      if (data.isSuccess == true) {
        // this.PanelGeofencesService.setLoading(false);
        console.log("request geofence",data.result);

        var emails = data.result.emailAlert;
        if (!emails.includes(localStorage.getItem("user"))) {
          emails = emails + ";" + localStorage.getItem("user");
        }

        if (!this.$isDuplicate){
          this.fullRequest.guid = data.result.guid;
          this.fullRequest.name = data.result.name;
        }
        this.fullRequest.identifiers = data.result.identifiers;
        this.fullRequest.emailAlert = emails;
        this.fullRequest.radio = data.result.radio.toString();
        this.fullRequest.idGeofenceType = data.result.idGeofenceType;
        this.fullRequest.idGeofenceCategory = data.result.idGeofenceCategory;

        //se obtienen los datos del geojson para poder modificar las coordenadas
        const geojson = JSON.parse(data.result.geom_GeoJSON)
        const coordinates = geojson.features[0].geometry.coordinates;
        //se meten al request todas las coordenadas obtenidas del geojson como un string[][] para poder ser leidas por el mapa
        coordinates[0].forEach((point: number[]) => {
        this.fullRequest.coords.push([point[1].toString(),point[0].toString()]);
         });
         //ya que los buffer tienen muchos puntos, si es mayor a 50, se consiidera buffer y el primer punto se agrega como latitud y longitud del centro
         //si tiene menos de 50 puntos, se considera poligono, se agregan todos los puntos al array de puntos del poligono y se agrega el control de dibujo
        if (this.fullRequest.coords.length > 50) {
          this.fullRequest.idGeometryType = EnumGeometryTypes.Buffer;
          this.mapHelperService.bufferCenterLat = parseFloat(data.result.geom_CentroidY);
          this.mapHelperService.bufferCenterLng = parseFloat(data.result.geom_CentroidX);
          this.mapHelperService.bufferRadioKm = data.result.radio;
          // this.mapHelperService.UpdateActiveBuffer(
          //   this.mapHelperService.lat,
          //   this.mapHelperService.lng,
          //   this.mapHelperService.radioKm
          // );
          this.panelAddGeofencesService.setVisibleControlSliderRadio(true);
          this.mapHelperService.addGeofencePolygonDrawControl();
          this.mapHelperService.drawGeofencePolygon.add(geojson.features[0]);
        }else if(this.fullRequest.coords.length <= 50){
          this.fullRequest.idGeometryType = EnumGeometryTypes.Polygon;
          this.fullRequest.coords.map((point: string[]) => this.mapHelperService.polygonPoints.push([parseFloat(point[1]),parseFloat(point[0])]));
          this.mapHelperService.addGeofencePolygonDrawControl();
          this.mapHelperService.drawGeofencePolygon.add(geojson.features[0]);
          console.log("draw", this.mapHelperService.drawGeofencePolygon);
          
        }
      }
    });
  }

  formatLabel(value: number) {
    if (value >= 1) {
      return value + "km";
    }
    return value;
  }

  CancelButton() {
    this.geofencesService.setVisiblePanelEditGeofences(false);
    this.geofencesService.setVisiblePanelGeofences(true);
    this.cleanForm();
    this.mapHelperService.FlyToCamera(
      "24.226252",
      "-103.0266765",
      "4.5",
      0
    );
    console.log("cerrando popup");
  }

  //filtro del array de identificadores seleccionados
  findFromVehiculeArray(vehiculosFinder){
    //si hay más de un caracter en el input, busca coincidencias, si no, regresa el array de identificadores al original
    if (vehiculosFinder.length > 0) {
      //checa si hay identificadores en la utilidad de filtro, si no, guarda los identificadores en la utilidad y los filtra con el request, si sí, solo los filtra con la utilidad 
      if (this.listIdentifiersFinderBackup.length == 0) {
        this.listIdentifiersFinderBackup = this.fullRequest.identifiers;
        this.fullRequest.identifiers = this.fullRequest.identifiers.filter(item => item.includes(vehiculosFinder.toUpperCase())); 
      }else{
        this.fullRequest.identifiers = this.listIdentifiersFinderBackup.filter(item => item.includes(vehiculosFinder.toUpperCase()));
      }
    }else{
      this.fullRequest.identifiers = this.listIdentifiersFinderBackup;
      this.listIdentifiersFinderBackup = [];
    }
  }

  //boton de seleccionar opciones de identificadores
  selectOption(option: string) {
    //checa si es el primer en el input, si sí, lo agrega a la utilidad de identificadores con una coma al final, si no, lo agrega con una coma al inicio y al final
    if (this.vehiculos == "") {
      this.vehiculos = this.vehiculoInput + ",";
    }else{
      this.vehiculos = this.vehiculos + this.vehiculoInput + ",";
    }
    //setea el valor del input como el de la utilidad de identificadores
    this.vehiculoInput = this.vehiculos;
  }

  selectVehicule() {
    this.filteredOptionsVehicules = this.controlVehicules.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.listIdentifiers.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  onFindVehicule(event) {
    var texto = event.target.value.toLowerCase();
    console.log(event);
    if (texto.length == 0) {
      this.filteredOptionsVehicules = this.controlVehicules.valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value))
      );
      console.log("reset filter...");
    }
  
    // Divide el texto en un array de identificadores separados por coma
    const identifiers = texto.split(",").map((item) => item.trim());
  
    // Toma el último identificador del array
    const lastIdentifier = identifiers[identifiers.length - 1];
  
    // Si el último identificador tiene al menos 1 caracter, busca coincidencias
    if (lastIdentifier.length >= 1) {
      this.subscription_FindByIdentifier = this.panelAddGeofencesService.findByIdentifier(lastIdentifier).subscribe((arg) => {
        this.listLocationsFind = arg.result;
        this.listIdentifiers = this.listLocationsFind.map(function (item) {
          return item.identifier;
        });
        console.log("buscando...");
      });
    }
  }

  //boton para agregar identificadores desde el input
  AddActive() {
    var text = this.vehiculoInput;
    this.isLoading = false;
    // Dividir el texto por comas y obtener un array de valores
    var values = text.split(',');
    values = values.filter(value => value != ""); // Eliminar el último elemento del array, que es un string vacío
  
    // Valida los vines enviados e Iterar sobre los valores verificados, despues los agrega al array si no existen
    
      try {
      this.subscription_validateIdentifier = this.locationService.postValidateIdentifiers(values).subscribe((data)=>{
          console.log(data);
        if (data.isSuccess) {
          var identifierErrores = data.result.invalidIdentifiers;
          var identificadoresValidados = data.result.validIdentifiers;
          console.log(identificadoresValidados, identifierErrores);

          if (identificadoresValidados.length < 1) {
            this.notifyService.MessageError(
              "Error. No hay vines corrrectos, verifique que estén bien escritos, le pertenezcan al usuario o a la empresa. Los identificadores ingresados son los siguientes: " + values.join(",") + ".",
            );
            this.isLoading = false;
            this.vehiculoInput = "";
            this.vehiculos = "";
            return;
          }

          identificadoresValidados.forEach((value) => {
            const trimmedValue = value.trim();
            if (!this.fullRequest.identifiers.includes(trimmedValue)) {
              if(this.listIdentifiersFinderBackup.length > 0 && !this.listIdentifiersFinderBackup.includes(trimmedValue)){
                this.fullRequest.identifiers.push(trimmedValue);
                this.listIdentifiersFinderBackup.push(trimmedValue);
              }else{
                this.fullRequest.identifiers.push(trimmedValue);
              }
            }
            });
          if (identifierErrores.length > 0) {
            this.notifyService.MessageSuccessful(
              "Correcto",
              "Se han cargado los vines a la lista, excepto: " + identifierErrores
            );
            this.isLoading = false;
          }
          else{
            this.notifyService.MessageSuccessful(
              "Correcto",
              "Se han cargado todos los vines a la lista"
            );
            this.isLoading = false;
          }
        }
        
      });
      } catch (error) {
        this.notifyService.MessageSuccessful(
          "Error",
          "No se han cargado los vines a la lista, contacte al administador"
        );
        this.isLoading = false;
      }
      
    //resetea el valor del input y la utilidad de autocompletado
    this.vehiculoInput = "";
    this.vehiculos = "";
  }

  setFeaturesToActives(features: any){
    console.log("setFeaturesToActives", features);
    if (features != null && features.length > 0) {
      var featureAgregados : string[] = [];
      var featureAgregadosBackup : string[] = [];
      var featureCorrectos = "";
      features.forEach(element => {
        var value = element.properties._Id;
        const trimmedValue = value.trim();
        console.log("feauture", value);
        if (!this.fullRequest.identifiers.includes(trimmedValue)) {
          if(this.listIdentifiersFinderBackup.length > 0 && !this.listIdentifiersFinderBackup.includes(trimmedValue)){
            featureAgregados.push(trimmedValue);
            featureAgregadosBackup.push(trimmedValue);
            // this.fullRequest.identifiers.push(trimmedValue);
            // this.listIdentifiersFinderBackup.push(trimmedValue);
          }else{
            // this.fullRequest.identifiers.push(trimmedValue);
            featureAgregados.push(trimmedValue);
          }
          featureCorrectos += trimmedValue + ", ";
        }
      });
      if (featureAgregados.length > 0) {
        var resp = this.notifyService.confirmMessage("Vines dentro de la geocerca","Desea que se agreguen los siguientes vines a la lista de identificadores?  " + featureCorrectos);
        resp.then((result) =>{
           if(result.value)
           {
            this.fullRequest.identifiers.push(...featureAgregados);
            this.listIdentifiersFinderBackup.push(...featureAgregadosBackup);
            }
         });
      }
    }
  }

  addAllActives(){
    // busca todos los iedentificadores que puede haber en un usuario, los agrega a la lista y hace set al array de utilidad para el buscador de identificadores
    this.subscription_GetList = this.locationService.getList().subscribe((data) => {
      this.fullRequest.identifiers = data.result.map(function (item) {
        return item.identifier;
      });
      this.listIdentifiersFinderBackup = this.fullRequest.identifiers;
    });
  }

  //boton para remover identificadores
  RemoveActive(value: string) {
    //checa si hay identificadores en la utilidad de filtro, si sí, los elimina de la utilidad y del array de identificadores, si no, solo los elimina del array de identificadores
    if (this.listIdentifiersFinderBackup.length > 0) {
      var index = this.fullRequest.identifiers.indexOf(value);
      if (index !== -1) this.fullRequest.identifiers.splice(index, 1);
      index = this.listIdentifiersFinderBackup.indexOf(value);
      if (index !== -1) this.listIdentifiersFinderBackup.splice(index, 1);
    }else{
      var index = this.fullRequest.identifiers.indexOf(value);
      if (index !== -1) this.fullRequest.identifiers.splice(index, 1);
    }
  }

  //boton para remover todos los identificadores
  removeAllActives(){
    var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar todos los identificadores?");
    resp.then((result) =>{
       if(result.value)
       {
        this.fullRequest.identifiers = [];
        this.listIdentifiersFinderBackup = [];
    }
   }); 
  }

  onChangeRadio(event) {
    this.fullRequest.radio = event.value;
  }

  //boton de seleccionar vertices
  // createPolygonPoints() {
  //   //checa si ya hay un poligono dibujado, si no, permite crear uno nuevo
  //   if (this.mapHelperService.drawGeofencePolygon.getAll().features.length < 1) {
  //     this.isPolygonButtonMsgVisible = true;
  //     //checa si el poligono se está editando, si sí, eliminar el poligono y permitir crear uno nuevo
  //     //si está creando uno nuevo, no permite crear otro hasta que se elimine el que ya está creado
  //     if (this.$guidEditable != "") {
  //       console.log("editando poligono si guid", this.mapHelperService.drawGeofencePolygon.getAll().features, this.$guidEditable);
  //       this.mapHelperService.drawGeofencePolygon.deleteAll();
  //       this.mapHelperService.drawGeofencePolygon.changeMode('draw_polygon');
  //       this.AddPolygonSelected = "create";
  //     }else{
  //       console.log("editando poligono no guid", this.mapHelperService.drawGeofencePolygon.getAll().features, this.$guidEditable);
  //       this.mapHelperService.drawGeofencePolygon.changeMode('draw_polygon');
  //       this.AddPolygonSelected = "create";
  //     }
  //   }
  //   else{
  //     console.log("editando poligono", this.mapHelperService.drawGeofencePolygon.getAll().features, this.mapHelperService.drawGeofencePolygon.getAll());
  //     this.notificationToastService.showError("Ya se ha creado un polígono","Error al Crear Polígono");
  //   }
  // }

  //boton de editar vertices
  // editPolygonPoints(){
  //   //checa si ya hay un poligono dibujado, si no, manda mensaje de error, si sí, permite editar los vertices
  //   if (this.mapHelperService.drawGeofencePolygon.getAll().features != null || this.mapHelperService.drawGeofencePolygon.getAll().features.length > 0) {
  //     this.isPolygonEditButtonMsgVisible = true;
  //     const lastFeatureId = this.mapHelperService.drawGeofencePolygon.getAll().features[0] != null ? this.mapHelperService.drawGeofencePolygon.getAll().features[0].id.toString() : null;
  //     this.mapHelperService.drawGeofencePolygon.changeMode('direct_select' , { featureId: lastFeatureId });
  //     this.AddPolygonSelected = "edit";
  //     this.fullScreen = false;
  //   }else{
  //     this.notificationToastService.showError("No se ha creado un polígono","Error al Editar Polígono");
  //   }
  // }

  // //boton de eliminar vertices
  // deletePolygonPoints(){
  //     this.mapHelperService.drawGeofencePolygon.deleteAll();
  //     this.mapHelperService.updatePolygonArea('draw.delete');
  //     this.AddPolygonSelected = "";
  // }

  //boton de cambiar tipo de geocerca
  onChangeGeofenceType(value){
    this.fullRequest.idGeofenceType = value;
  }

  //boton de cambiar categoria de geocerca
  onChangeGeofenceCategory(value){
    this.fullRequest.idGeofenceCategory = value;
  }

  //boton de agregar el centro del buffer y elimina el draw control, en caaso de que esté activo
  // onSetBufferCenter() {
  //   this.isBufferButtonMsgVisible = true;
  //   this.mapHelperService.AddBufferGeofenceMode = true;
  //   this.mapHelperService.AddPolygonGeofenceMode = false;
  //   this.mapHelperService.toggleDrawControl();
  // }

  //función para de añadir el control draw de mapbox
  // addDraw() {
  //   console.log("añadiendo draw",this.mapHelperService.AddPolygonGeofenceMode);
  //   if (!this.mapHelperService.AddPolygonGeofenceMode) {
  //     this.mapHelperService.AddPolygonGeofenceMode = true;
  //     this.mapHelperService.toggleDrawControl();
  //   }
  // }
  
  //función para seleccionar el tipo de geometría
  selectGeometry(geometria){
    this.fullRequest.idGeometryType = 0;

    //resetea los valores de latitud y longitud del buffer
    this.mapHelperService.bufferCenterLat = 0;
    this.mapHelperService.bufferCenterLng = 0;
    this.fullRequest.coords = [];
    
    this.fullRequest.idGeometryType = geometria;
    //si se elecciona el tipo buffer, se resetean los otros valores
    // if (geometria == EnumGeometryTypes.Buffer) {
    //   // resetea el valor del poligono
    //   this.AddPolygonSelected = "";
    //   this.mapHelperService.UpdateLayerGeoJson("PolygonActiveSource",this.mapHelperService.Empty_GeoJson);
    //   this.mapHelperService.polygonPoints = [];
    //   this.fullRequest.coords = [];
    //   this.onSetBufferCenter();
    // }else 
    // //si se elecciona el tipo poligono, se resetean los otros valores
    // if(geometria == EnumGeometryTypes.Polygon){
    //   this.addDraw();
    //   // reseta los valores del buffer
    //   this.mapHelperService.bufferRadioKm = 0.1;
    //   this.initialRadio = "0.1";
    //   this.fullRequest.radio = this.initialRadio.toString();
    //   this.fullRequest.coords = [];
    //   this.mapHelperService.ResetActiveBuffer();
    //   this.panelAddGeofencesService.setVisibleControlSliderRadio(false);

    //   this.createPolygonPoints();
    // }else 
    // //si se elecciona el tipo multipoligono, se resetean los otros valores
    // if(geometria == 0){
    //   // reseta los valores del buffer
    //   this.mapHelperService.radioKm = 0.1;
    //   this.initialRadio = "0.1";
    //   this.fullRequest.radio = this.initialRadio.toString();
    //   this.mapHelperService.AddBufferGeofenceMode = false;
    //   this.mapHelperService.ResetActiveBuffer();
    //   this.panelAddGeofencesService.setVisibleControlSliderRadio(false);
    //   // resetea el valor del poligono
    //   this.AddPolygonSelected = "";
    //   this.mapHelperService.UpdateLayerGeoJson("PolygonActiveSource",this.mapHelperService.Empty_GeoJson);
    //   this.mapHelperService.polygonPoints = [];
    //   this.fullRequest.coords = [];
    //   this.mapHelperService.AddPolygonGeofenceMode = false;
    //   this.mapHelperService.toggleDrawControl();
    // }
  }

  //boton para seleccionar el tipo de monitoreo (full o personalizado)
  selectMonitoring(monitorinType : string){
    this.fullRequest.alarmType = monitorinType;
  }

  //boton para seleccionar el tipo de recurrencia (individual o rango) y resetea los días seleccionados
  selectFrecuency(frecuencyType : string){
    this.fullRequest.alarmFrecuency = frecuencyType;
    this.days.forEach(day => day.selected = false);
  }

  //función para seleccionar los días de la semana
  selectDay(day: any) {
    console.log("Día seleccionado",day);
  }

  onSaveChanges() {
    this.isLoading = true;
    //regresa los identificadores al request, en caos de que no esté vacío
    if (this.listIdentifiersFinderBackup.length > 0) {
      this.fullRequest.identifiers = this.listIdentifiersFinderBackup;
      this.listIdentifiersFinderBackup = [];
    }
      

    //ingresar días seleccionados al arreglo de días y horas seleccionadas
    this.fullRequest.alarmDays = this.days.filter(day => day.selected).map(day => day.initial);

    if (this.fullRequest.alarmFrecuency == "individual") {
      this.fullRequest.alarmIndividualTime = [this.horaInicio,this.horaFin];
      console.log("Horas seleccionadas",this.fullRequest.alarmIndividualTime);
    }
    else if (this.fullRequest.alarmFrecuency == "range") {
      this.fullRequest.alarmRangeTime = [this.diasTotales.toString(),this.horaInicio,this.horaFin, this.horasTotales.toString()];
    }

    
    //Recuperar coordenadas de acuerdo al tipo de geometría ---- LA ESTA MANDANDO COMO [LAT, LNG], por eso están como [1],[0]
    if (this.fullRequest.idGeometryType == EnumGeometryTypes.Buffer) {

      if (this.mapHelperService.polygonPoints.length > 30) {
        var centroide = this.mapHelperService.getpolygonPointsCentroid(this.mapHelperService.polygonPoints);
        this.fullRequest.coords = [[centroide[1].toString(), centroide[0].toString()]];
      }else{
        this.fullRequest.coords = [[this.mapHelperService.lat.toString(), this.mapHelperService.lng.toString()]];
      }

    } else if (this.fullRequest.idGeometryType == EnumGeometryTypes.Polygon) {
      this.fullRequest.coords = this.mapHelperService.polygonPoints.map(point => [point[1].toString(),point[0].toString()] as string[]);
    } else if (this.fullRequest.idGeometryType == EnumGeometryTypes.Zone) {
      //para multi poligono, traigo los poligonos del maphelper y los transformo
      //CREE UN NUEVO ATRIBUTO EN EL REQUEST ---- CHECAR SI ASÍ O NO ----
      this.fullRequest.multiplePolygonCoords = this.panelAddGeofencesService.selectedFeatures.features.map( feature => {
        var polygonExternalRing = feature.geometry.coordinates[0];
        var coords = polygonExternalRing.map(point => [point[1].toString(), point[0].toString()]);
        return coords;
      });
      this.fullRequest.coords = this.fullRequest.multiplePolygonCoords.length > 0 ? this.fullRequest.multiplePolygonCoords[0] : [];
    } 

    console.log("REQUEST2",this.fullRequest);

    //Insertar objeto Geocerca
    if(this.fullRequest.name.length>0)
    {
    if (this.fullRequest.idGeometryType != null && this.fullRequest.idGeometryType > 0 ) {
      if (this.fullRequest.coords.some(coord => coord.length > 0 && coord[0] !== "0" && coord[1] !== "0") || (this.fullRequest.multiplePolygonCoords != null && this.fullRequest.multiplePolygonCoords.length > 0)) {
        if (this.fullRequest.alarmType == "full" || this.fullRequest.alarmFrecuency.length > 0) {
          if (this.fullRequest.alarmType == "full" || this.fullRequest.alarmDays.length > 0) {
            this.subscription_InsertV2 = this.geofencesService.InsertV2(this.fullRequest).subscribe((data) => {
               console.log("RESPONSE",data);
               if(data.isSuccess){
                 this.geofencesService.setVisiblePanelEditGeofences(false);
                 this.geofencesService.setVisiblePanelGeofences(true);
                 this.notificationToastService.showSuccess("Geocerca Creada o Actualizada Exitosamente","Cambios Exitosos en Geocerca");
                 this.cleanForm();
                 this.isLoading = false;
                 this.internalLayerService.DeactivateLayer(this.internalLayerService.geofenceLayer);
                 this.internalLayerService.ActivateLayer(this.internalLayerService.geofenceLayer);
               }else{
                 this.notificationToastService.showError("No pudimos crear la geocerca, contacte al administrador","Error al Crear Geocerca");
                 this.isLoading = false;
               }
             });
          }else{
            this.notificationToastService.showError("No se han seleccionado días para la recurrencia de monitoreo","Error al Crear Geocerca");
            this.isLoading = false;
          }
        }else{
          this.notificationToastService.showError("No se ha seleccionado la recurrencia de monitoreo","Error al Crear Geocerca");
          this.isLoading = false;
        }
      }else{
        this.notificationToastService.showError("No se han seleccionado puntos para la geometría de la geocerca, asegurese de dar doble clic a un punto si ya la creó","Error al Crear Geocerca");
        this.isLoading = false;
      }
    }else{
      this.notificationToastService.showError("No se ha seleccionado el tipo de geometría","Error al Crear Geocerca");
      this.isLoading = false;
    }
  }else{
    this.notificationToastService.showError("No se ha seleccionado el nombre de la Geocerca","Error al Crear Geocerca");
      this.isLoading = false;
  }
  }

  selectTab(event: MatTabChangeEvent) {
    if (event.index == 0) {
      this.selectedTabIndex = 0;
    }else if (event.index == 1){
      this.selectedTabIndex = 1;
    }else{
      this.selectedTabIndex = 2;
    }
  }
  selectTabButton(direction: string){
    if (direction == "next") {
      this.selectedTabIndex++;
      
    }else if (direction == "prev"){
      this.selectedTabIndex--;
    }

    if (this.selectedTabIndex < 0)
      this.selectedTabIndex = 0;
    if (this.selectedTabIndex > 2)
      this.selectedTabIndex = 2;
  }

  toggleStatusCheckbox() {
    console.log("status",this.fullRequest.status);
  }

  calcularRango() {
    if (this.diaInicial && this.diaFinal && this.horaInicio && this.horaFin) {
      // Reinicia la selección de días
      this.days.forEach(day => day.selected = false);
      this.days.find(day => day.name === this.diaInicial.name).selected = true;
      this.days.find(day => day.name === this.diaFinal.name).selected = true;

      // Encuentro el índice del día inicial y final en el arreglo "days"
      const indexInicial = this.days.findIndex(day => day === this.diaInicial);
      const indexFinal = this.days.findIndex(day => day === this.diaFinal);
  
      if (indexInicial !== -1 && indexFinal !== -1) {
        // Calcula la diferencia en días teniendo en cuenta el sentido, para calcular la semana completa
         this.diasTotales = 0;
  
        if (indexFinal >= indexInicial) {
          this.diasTotales = indexFinal - indexInicial;
        } else {
          this.diasTotales = (this.days.length - indexInicial) + indexFinal;
        }
  
        // Parsea las horas de inicio y fin en formato HH:mm
        const horaInicioParts = this.horaInicio.split(':');
        const horaFinParts = this.horaFin.split(':');
  
        if (horaInicioParts.length === 2 && horaFinParts.length === 2) {
          const horasInicio = parseInt(horaInicioParts[0]);
          const minutosInicio = parseInt(horaInicioParts[1]);
          const horasFin = parseInt(horaFinParts[0]);
          const minutosFin = parseInt(horaFinParts[1]);
  
          // Calcula la diferencia en horas
          let horas = (horasFin - horasInicio) + ((minutosFin - minutosInicio) / 60);
  
          if (horas < 0) {
            // Si la hora final es anterior a la hora inicial en el mismo día, ajusta la diferencia de horas
            horas = horas*-1;
            this.diasTotales--; // quita un día
          }
  
          // Calcula el número total de horas entre los días inicial y final, si es negativo, significa que el día final es igual al inicial pero con hora anterior
          if (this.diasTotales < 0) {
            this.diasTotales = 6;
            this.horasTotales = (this.diasTotales * 24) + horas;
          }else{
            this.horasTotales = (this.diasTotales * 24) + horas;
          }
          
  
          // Asigna el resultado a la variable rangoCalculado
          this.rangoCalculado = `Número de horas entre ${this.diaInicial.name} ${this.horaInicio} y ${this.diaFinal.name} ${this.horaFin}: ${this.horasTotales} horas`; 
          console.log(`Número de horas entre ${this.diaInicial.name} ${this.horaInicio} y ${this.diaFinal.name} ${this.horaFin}: ${this.horasTotales} horas`);
        }
      }
    }
  }
  cleanForm() {
    this.fullRequest = {
      guid: "",
    status: true,
    name: "",
    coords: [],
    multiplePolygonCoords: [],
    identifiers: [],
    radio: this.initialRadio,
    idGeofenceType: EnumGeofenceTypes.SecureZone_AlertOnExit,
    emailAlert: "test@einteligent.com.mx",
    idGeometryType: EnumGeometryTypes.Buffer,
    idGeofenceCategory: 1,
    alarmType: "full",
    alarmFrecuency: "",
    alarmDays: [],
    alarmIndividualTime: [],
    alarmRangeTime: [],
    phoneAlert: "",
    };
    this.mapHelperService.bufferCenterLat = 0;
    this.mapHelperService.bufferCenterLng = 0;
    // reseta los valores del buffer
    this.mapHelperService.bufferRadioKm = 0.1;
    this.initialRadio = "0.1";
    this.fullRequest.radio = this.initialRadio.toString();
    this.mapHelperService.ResetActiveBuffer();
    this.mapHelperService.removeBufferDrawControl();
    this.panelAddGeofencesService.setVisibleControlSliderRadio(false);
    // resetea el valor del poligono
    this.mapHelperService.UpdateLayerGeoJson("PolygonActiveSource",this.mapHelperService.Empty_GeoJson);
    this.mapHelperService.polygonPoints = [];
    this.fullRequest.coords = [];
    this.mapHelperService.removeGeofencePolygonDrawControl();
    //resetea tilidades de monitoreo e identificadores
    this.vehiculoInput = "";
    this.vehiculos= "";
    this.listIdentifiersFinderBackup = [];
    this.days.forEach(day => day.selected = false);
    this.diaInicial = "";
    this.diaFinal = "";
    this.horaInicio = "06:00 AM";
    this.horaFin = "06:00 AM";
    this.horasTotales = 0;
    this.diasTotales = 0;
    this.rangoCalculado = "";
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
    
  }

  onVinClick(identifier: string) {
    this.subscription_OnFocusPin = this.locationService.getByIdentifier(identifier).subscribe((data: EstatusJSON) => {
      var PinSelected: LocationDTO;
          if (data.isSuccess == true) {
            console.log("PIN SELECTED");
            console.log(data.result);
            PinSelected = data.result;

            if (PinSelected.cordsX != "" && PinSelected.cordsY != "") {
              this.mapService.FocusePin(PinSelected.cordsY, PinSelected.cordsX);
              var obj = {
                lat: PinSelected.cordsY,
                lng: PinSelected.cordsX,
                idntf: PinSelected.identifier,
              };
  
              //Update Active Location
              // this.UpdateActiveLocation(obj);
            }else{
              this.notifyService.MessageError(
                "No se ha podido localizar el vehículo",
              );
            }
          }
          
        },
        (error) => {
        }
      );
  }


  // onVisibilityChange(isVisible: boolean) {
  //   this.isBufferButtonMsgVisible = isVisible;
  //   this.isPolygonButtonMsgVisible = isVisible;
  //   this.isPolygonEditButtonMsgVisible = isVisible;
  // }

  GetGeofenceEnums() {
     var enums = this.enumCatalogService.GetGeofenceEnums();

    this.listGeofenceCategories = enums.GeofenceCategories;
    this.listGeofenceTypes = enums.GeofenceTypes;

    
    console.log("enum", enums, this.listGeofenceCategories, this.listGeofenceTypes, EnumGeometryTypes);
  }

  StringToNumber(value: string) {
    return Number(value);
  }
}
